import { lazyLoad } from "../utils/LazyLoad";

export const LazySection = (url: string, ttl: number = 0) => ({
    html: '',
    loading: true,
    firstEntry: true,
    lastEntry: false,
    itemWidth: 0,

    init() {
        const el = this.$el as HTMLElement;
        const removeSkeleton = () => this.$nextTick(() => {
            el.querySelector('[data-skeleton]')?.remove();
            requestAnimationFrame(() => this.initGrid());
        });

        lazyLoad(el, url, {
            cacheKey: ttl > 0 ? `LazySection:${url}` : undefined,
            cacheTtl: ttl,
            onSuccess: (html) => {
                this.html = html;
                this.loading = false;
                removeSkeleton();
            },
            onError: () => {
                this.loading = false;
            }
        });
    },

    initGrid() {
        const grid = this.$refs.grid;
        if (!grid?.children?.length) return;
        this.itemWidth = (grid.children[0] as HTMLElement).offsetWidth;
        this.watchEntries();
    },

    scrollEntries(direction: string) {
        this.$refs.grid.scrollBy({
            top: 0,
            left: direction === 'next' ? this.itemWidth : this.itemWidth * -1,
            behavior: 'smooth'
        });
    },

    watchEntries() {
        const grid = this.$refs.grid;
        if (!grid) return;
        this.firstEntry = grid.scrollLeft <= 0;
        this.lastEntry = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 40;
    },

    nextBtn: {
        [':class']() { return { 'is-disabled': this.lastEntry }},
        ['@click']() { this.scrollEntries('next'); }
    },
    prevBtn: {
        [':class']() { return { 'is-disabled': this.firstEntry }},
        ['@click']() { this.scrollEntries('prev'); }
    },
});
